import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { useProjects } from '../useProjects/useProjects'
import { IProjectStatus } from '~/@api/generated-api-types-project/Api'

function useRunningProjectsQuery() {
  const { fetchProjects } = useProjects([IProjectStatus.Running])

  return useQuery({
    queryKey: ['running-projects'],
    queryFn: fetchProjects,
    // throwOnError: true,
    placeholderData: keepPreviousData,
  })
}

export { useRunningProjectsQuery }
